import { Capability } from '../../../../../../domain'

import { BaseSubscriptionStrategy } from '../Base'

export class ServicesDataResourcesStrategy extends BaseSubscriptionStrategy<'serviceResources'> {
    readonly requiredPermissions = [Capability.SERVICE_SUBSCRIPTION_METADATA]
}
